import 'jquery-mask-plugin';
import 'select2/dist/js/select2.full.min'

export default {
  init() {
    //console.log('DOSTAWY INIT');

    $('#kod-pocztowy').mask('00-000')

    // INTERAKTYWNA MAPA

    $(document).ready(function() {

      $('#first-step-zone-01 select').select2({
        width: '100%',
        minimumResultsForSearch: -1,
        placeholder: 'Wybierz WOJEWÓDZTWO',
        allowClear: false,
      });

      $('#first-step-zone-02 select').select2({
        width: '100%',
        minimumResultsForSearch: -1,
        placeholder: 'Wybierz WOJEWÓDZTWO',
        allowClear: false,
      });

      // Bind an events
      $('#first-step-zone-01 select').on('select2:select', function (e) {
        // Synchronizuj pomiędzy selectami
        const provinceSelected = $(this).val();
        $('#first-step-zone-02 select').val(provinceSelected).trigger('change');
        //console.log($(this).val());
        // wybierz miasto na mapie
        $('.province-map-btn-strefy').removeClass('active');
        $('.province-map-btn-strefy[data-province=' + provinceSelected + ']').addClass('active');
        $('#miasta-list-strefy ul').removeClass('active');
        $('ul.miasta-list-strefy li').removeClass('active')
        // CITY PART
        $('#miasta-list-strefy #default-list-placeholder').hide();
        $('#miasta-list-strefy ul[data-province=' + provinceSelected + ']').addClass('active');
        $('#second-step-zone-01').removeClass('selected');
        $('#second-step-zone-02').removeClass('selected');
        $('#second-step-zone-01 span').html('WYBIERZ MIASTO');
        $('#second-step-zone-02 span').html('WYBIERZ MIASTO');
        $('#check-postcode').css('display', 'flex');
      });

      $('#first-step-zone-02 select').on('select2:select', function (e) {
        // Synchronizuj pomiędzy selectami
        const provinceSelected = $(this).val();
        $('#first-step-zone-01 select').val(provinceSelected).trigger('change');
        // console.log($(this).val());
        // wybierz miasto na mapie
        $('.province-map-btn-strefy').removeClass('active');
        $('.province-map-btn-strefy[data-province=' + provinceSelected + ']').addClass('active');
        $('#miasta-list-strefy ul').removeClass('active');
        $('ul.miasta-list-strefy li').removeClass('active')
        // CITY PART
        $('#miasta-list-strefy #default-list-placeholder').hide();
        $('#miasta-list-strefy ul[data-province=' + provinceSelected + ']').addClass('active');
        $('#second-step-zone-01').removeClass('selected');
        $('#second-step-zone-02').removeClass('selected');
        $('#second-step-zone-01 span').html('WYBIERZ MIASTO');
        $('#second-step-zone-02 span').html('WYBIERZ MIASTO');
        $('#check-postcode').css('display', 'flex');
      });

      // SELECT PROVINCE & SHOW CITIES
      $('#mapa-strefy .province-map-btn-strefy').on('click', function () {
        const provinceSelected = $(this).attr('data-province');
        $('#first-step-zone-01 select').val(provinceSelected).trigger('change');
        $('#first-step-zone-02 select').val(provinceSelected).trigger('change');
        // console.log(provinceSelected);
        $('.province-map-btn-strefy').removeClass('active');
        $('.province-map-btn-strefy[data-province=' + provinceSelected + ']').addClass('active');
        $('#miasta-list-strefy ul').removeClass('active');
        $('ul.miasta-list-strefy li').removeClass('active')
        // CITY PART
        $('#miasta-list-strefy #default-list-placeholder').hide();
        $('#miasta-list-strefy ul[data-province=' + provinceSelected + ']').addClass('active');
        $('#second-step-zone-01').removeClass('selected');
        $('#second-step-zone-02').removeClass('selected');
        $('#second-step-zone-01 span').html('WYBIERZ MIASTO');
        $('#second-step-zone-02 span').html('WYBIERZ MIASTO');
        $('#check-postcode').css('display', 'flex');
      });

      // SELECT CITY & SHOW ZONES
      $('ul.miasta-list-strefy li').on('click', function () {
        const godziny = $(this).attr('data-godziny');
        // console.log(godziny);
        $('ul.miasta-list-strefy li').removeClass('active')
        $(this).addClass('active');
        $('#second-step-zone-01').addClass('selected');
        $('#second-step-zone-02').addClass('selected');
        $('#second-step-zone-01 span').html(godziny);
        $('#second-step-zone-02 span').html(godziny);
        if(screen.width < 992){
          $('html, body').animate({
            scrollTop: $('#second-step-zone-02').offset().top - 200,
          }, 500);
        }
      });


      // KODY POCZTOWE - check if imput empty
      var inpsToMonitor = document.querySelectorAll (
        "input.empty-check"
      );

      for (var J = inpsToMonitor.length - 1;  J >= 0;  --J) {
        inpsToMonitor[J].addEventListener ("change",    adjustStyling, false);
        inpsToMonitor[J].addEventListener ("keyup",     adjustStyling, false);
        inpsToMonitor[J].addEventListener ("focus",     adjustStyling, false);
        inpsToMonitor[J].addEventListener ("blur",      adjustStyling, false);
        inpsToMonitor[J].addEventListener ("mousedown", adjustStyling, false);

        //-- Initial update. note that IE support is NOT needed.
        var evt = document.createEvent ("HTMLEvents");
        evt.initEvent ("change", false, true);
        inpsToMonitor[J].dispatchEvent (evt);
      }

      function adjustStyling (zEvent) {
        var inpVal  = zEvent.target.value;
        if (inpVal  &&  inpVal.replace (/^\s+|\s+$/g, "") ) {
          zEvent.target.classList.add('active');
          $('#sprawdz-kod-pocztowy').removeAttr('disabled');
        } else {
          zEvent.target.classList.remove('active');
          $('#sprawdz-kod-pocztowy').attr('disabled', true);
        }
      }

    });

    $('#sprawdz-kod-pocztowy').on('click', function () {
      const kodPocztowy = $('#kod-pocztowy').val();
      // console.log(kodPocztowy);
      // console.log(kodyPocztowe.includes(kodPocztowy));

      // eslint-disable-next-line no-undef
      if (kodyPocztowe.includes(kodPocztowy)) {
        // console.log('DOWOZIMY!');
        $('#default-placeholder').hide();
        $('#allowed-img-link').show();
        $('#not-allowed-img').hide();
        $('#more-info-col').hide();
      } else {
        // console.log('NIE DOWOZIMY :(');
        $('#default-placeholder').hide();
        $('#allowed-img-link').hide();
        $('#not-allowed-img').show();
        $('#more-info-col').show();
      }

    });

    $('#kod-pocztowy').keyup(function() {
      setTimeout(function() {
        if (screen.width >= 992) {
          $('#default-placeholder').show();
        }
        $('#allowed-img-link').hide();
        $('#not-allowed-img').hide();
        $('#more-info-col').hide();
      }, 500);
    });

  },
}
